import { getEmployee, getSelectableEmployees } from "../../models/employees";
import "./employeeSelect.css";

export default function EmployeeSelect({
  selectedEmployee,
  onSelectedEmployee,
}) {
  return (
    <div className="employeeSelectWrapper">
      <label className="employeeSelectLabel" htmlFor="employeeSelect">
        Vyberte barbera
      </label>
      <select
        id="employeeSelect"
        className="employeeSelect"
        value={selectedEmployee.id}
        onChange={(e) =>
          onSelectedEmployee(getEmployee(parseInt(e.target.value)))
        }
      >
        {getSelectableEmployees().map((employee) => (
          <option key={employee.id} value={employee.id}>
            {employee.name} - {employee.level.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}
